/**
 * Централизованный список валют
 * Используется во всех частях приложения (mobile, web)
 */

export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

/**
 * Полный список поддерживаемых валют
 */
export const currencies: Currency[] = [
  { code: 'RUB', name: 'Российский рубль', symbol: '₽' },
  { code: 'USD', name: 'Доллар США', symbol: '$' },
  { code: 'EUR', name: 'Евро', symbol: '€' },
  { code: 'GBP', name: 'Фунт стерлингов', symbol: '£' },
  { code: 'JPY', name: 'Японская иена', symbol: '¥' },
  { code: 'CNY', name: 'Китайский юань', symbol: '¥' },
  { code: 'KZT', name: 'Казахский тенге', symbol: '₸' },
  { code: 'UAH', name: 'Украинская гривна', symbol: '₴' },
  { code: 'BYN', name: 'Белорусский рубль', symbol: 'Br' },
  { code: 'TRY', name: 'Турецкая лира', symbol: '₺' },
  { code: 'INR', name: 'Индийская рупия', symbol: '₹' },
  { code: 'BRL', name: 'Бразильский реал', symbol: 'R$' },
  { code: 'AUD', name: 'Австралийский доллар', symbol: 'A$' },
  { code: 'CAD', name: 'Канадский доллар', symbol: 'C$' },
  { code: 'CHF', name: 'Швейцарский франк', symbol: 'CHF' },
  { code: 'SEK', name: 'Шведская крона', symbol: 'kr' },
  { code: 'NOK', name: 'Норвежская крона', symbol: 'kr' },
  { code: 'DKK', name: 'Датская крона', symbol: 'kr' },
  { code: 'PLN', name: 'Польский злотый', symbol: 'zł' },
  { code: 'CZK', name: 'Чешская крона', symbol: 'Kč' },
  { code: 'HUF', name: 'Венгерский форинт', symbol: 'Ft' },
  { code: 'RON', name: 'Румынский лей', symbol: 'lei' },
  { code: 'BGN', name: 'Болгарский лев', symbol: 'лв' },
  { code: 'HRK', name: 'Хорватская куна', symbol: 'kn' },
  { code: 'RSD', name: 'Сербский динар', symbol: 'дин' },
  { code: 'AED', name: 'Дирхам ОАЭ', symbol: 'د.إ' },
  { code: 'SAR', name: 'Саудовский риял', symbol: '﷼' },
  { code: 'QAR', name: 'Катарский риал', symbol: '﷼' },
  { code: 'KWD', name: 'Кувейтский динар', symbol: 'د.ك' },
  { code: 'ILS', name: 'Израильский шекель', symbol: '₪' },
  { code: 'EGP', name: 'Египетский фунт', symbol: 'E£' },
  { code: 'ZAR', name: 'Южноафриканский рэнд', symbol: 'R' },
  { code: 'NGN', name: 'Нигерийская найра', symbol: '₦' },
  { code: 'KES', name: 'Кенийский шиллинг', symbol: 'KSh' },
  { code: 'GHS', name: 'Ганский седи', symbol: '₵' },
  { code: 'MXN', name: 'Мексиканское песо', symbol: '$' },
  { code: 'ARS', name: 'Аргентинское песо', symbol: '$' },
  { code: 'CLP', name: 'Чилийское песо', symbol: '$' },
  { code: 'COP', name: 'Колумбийское песо', symbol: '$' },
  { code: 'PEN', name: 'Перуанский соль', symbol: 'S/' },
  { code: 'VES', name: 'Венесуэльский боливар', symbol: 'Bs.' },
  { code: 'UYU', name: 'Уругвайское песо', symbol: '$U' },
  { code: 'KRW', name: 'Южнокорейская вона', symbol: '₩' },
  { code: 'SGD', name: 'Сингапурский доллар', symbol: 'S$' },
  { code: 'HKD', name: 'Гонконгский доллар', symbol: 'HK$' },
  { code: 'TWD', name: 'Новый тайваньский доллар', symbol: 'NT$' },
  { code: 'THB', name: 'Таиландский бат', symbol: '฿' },
  { code: 'MYR', name: 'Малайзийский ринггит', symbol: 'RM' },
  { code: 'IDR', name: 'Индонезийская рупия', symbol: 'Rp' },
  { code: 'PHP', name: 'Филиппинское песо', symbol: '₱' },
  { code: 'VND', name: 'Вьетнамский донг', symbol: '₫' },
  { code: 'PKR', name: 'Пакистанская рупия', symbol: '₨' },
  { code: 'BDT', name: 'Бангладешская така', symbol: '৳' },
  { code: 'LKR', name: 'Шри-ланкийская рупия', symbol: 'Rs' },
  { code: 'NPR', name: 'Непальская рупия', symbol: 'Rs' },
  { code: 'MMK', name: 'Мьянманский кьят', symbol: 'K' },
  { code: 'KHR', name: 'Камбоджийский риель', symbol: '៛' },
  { code: 'LAK', name: 'Лаосский кип', symbol: '₭' },
  { code: 'GEL', name: 'Грузинский лари', symbol: '₾' },
  { code: 'AMD', name: 'Армянский драм', symbol: '֏' },
  { code: 'AZN', name: 'Азербайджанский манат', symbol: '₼' },
  { code: 'UZS', name: 'Узбекский сум', symbol: "so'm" },
  { code: 'KGS', name: 'Киргизский сом', symbol: 'с' },
  { code: 'TJS', name: 'Таджикский сомони', symbol: 'ЅМ' },
  { code: 'TMT', name: 'Туркменский манат', symbol: 'm' },
  { code: 'MDL', name: 'Молдавский лей', symbol: 'L' },
  { code: 'NZD', name: 'Новозеландский доллар', symbol: 'NZ$' },
  { code: 'ISK', name: 'Исландская крона', symbol: 'kr' },
];

/**
 * Получает символ валюты по коду
 * @param currencyCode - Код валюты (например, 'USD', 'RUB')
 * @returns Символ валюты или сам код, если валюта не найдена
 */
export function getCurrencySymbol(currencyCode: string): string {
  const currency = currencies.find(c => c.code === currencyCode);
  return currency?.symbol || currencyCode;
}

/**
 * Получает информацию о валюте по коду
 * @param currencyCode - Код валюты
 * @returns Объект Currency или undefined
 */
export function getCurrencyByCode(currencyCode: string): Currency | undefined {
  return currencies.find(c => c.code === currencyCode);
}

/**
 * Форматирует сумму в указанной валюте
 * @param amount - Сумма
 * @param currencyCode - Код валюты (по умолчанию RUB)
 * @param locale - Локаль для форматирования (по умолчанию ru-RU)
 * @returns Отформатированная строка с суммой
 */
export function formatCurrency(
  amount: number,
  currencyCode: string = 'RUB',
  locale: string = 'ru-RU'
): string {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
    }).format(amount);
  } catch (error) {
    // Fallback если валюта не поддерживается Intl
    const symbol = getCurrencySymbol(currencyCode);
    return `${symbol}${amount.toFixed(2)}`;
  }
}

/**
 * Список языков приложения
 */
export interface Language {
  code: string;
  name: string;
}

export const languages: Language[] = [
  { code: 'ru', name: 'Русский' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'pt', name: 'Português' },
  { code: 'de', name: 'Deutsch' },
  { code: 'fr', name: 'Français' },
  { code: 'it', name: 'Italiano' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'uk', name: 'Українська' },
  { code: 'be', name: 'Беларуская' },
  { code: 'pl', name: 'Polski' },
  { code: 'kk', name: 'Қазақша' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'cs', name: 'Čeština' },
  { code: 'sv', name: 'Svenska' },
  { code: 'id', name: 'Bahasa Indonesia' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'zh-Hans', name: '简体中文' },
  { code: 'zh-Hant', name: '繁體中文' },
  { code: 'ar', name: 'العربية' },
  { code: 'hi', name: 'हिन्दी' },
  { code: 'th', name: 'ไทย' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'ms', name: 'Bahasa Melayu' },
  { code: 'el', name: 'Ελληνικά' },
  { code: 'hu', name: 'Magyar' },
  { code: 'da', name: 'Dansk' },
  { code: 'he', name: 'עברית' },
  { code: 'ca', name: 'Català' },
  { code: 'nb', name: 'Norsk Bokmål' },
  { code: 'ro', name: 'Română' },
  { code: 'sk', name: 'Slovenčina' },
  { code: 'fi', name: 'Suomi' },
  { code: 'hr', name: 'Hrvatski' },
];

/**
 * Получает название языка по коду
 */
export function getLanguageName(languageCode: string): string {
  const language = languages.find(l => l.code === languageCode);
  return language?.name || languageCode.toUpperCase();
}

